import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DynamicFormControlDirective } from '../../dynamic-form-control.directive';
import { AbstractDynamicFormControl } from '../../abstact-dynamic-form-control.directive';

@Component({
  selector: 'dynamic-form-toggle-control',
  templateUrl: 'toggle-control.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule],
  providers: [
    { provide: DynamicFormControlDirective, useExisting: DynamicFormToggleControlComponent },
  ],
})
export class DynamicFormToggleControlComponent extends AbstractDynamicFormControl<boolean> {
  toggle(): void {
    this.control.setValue(!this.control.value);
    this.control.markAsDirty();
  }
}
